<app-log-out 
    [logOutModal]= "logOut"
    (returnSign)="returnSign()"
></app-log-out>
<div class="menu-container">
    <div class="button-back" *ngIf="showMenu">
        <div (click)="backMenu()" *ngIf="showBackButton">
            <bc-icon name="angle-left" class="icon-back"> </bc-icon> 
            <p>Volver</p>       
        </div>
    </div>
    <div class="bancolombia-logo">
        <img src="../../../../../assets/img/bancolombia-logo.png" alt="">
    </div>
    <div class="logout-button" *ngIf="showMenu">
        <div (click)="logOutModal()" *ngIf="showLogOutButton" >
            <p>Salir</p>
            <bc-icon name="quit" class="icon-logout"> </bc-icon>       
        </div> 
    </div>
</div>

